<template>
  <div id="app">
    <NavTop v-if="$route.path !== '/home'"/>

    <router-view v-if="isRouterAlive"></router-view>
    <Footer/>
  </div>
</template>

<script>
import NavTop from "./components/comcomponents/NavTop"
import Footer from "./components/comcomponents/Footer2"

export default {
  name: 'App',
  components: {
    NavTop,
    Footer
  },
  provide() { // 父组件中返回要传给下级的数据
    return {
      reload: this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  methods:{
    async reload() {
      this.isRouterAlive = false
      //通过this.$nextTick()产生一个微任务,在一次dom事件循环后,重新创建组件
      this.$nextTick()
      this.isRouterAlive = true
    }

  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue